"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = void 0;
var _auth = require("@ori/auth");
var _favoritesHeart = require("@ori/favorites-heart");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _internal = require("../../hooks/internal");
var _useTranslations = require("../../hooks/useTranslations");
var _PrimaryButton = require("../PrimaryButton");
var _SubscribeButton = require("../SubscribeButton");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Buttons = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    currentShade: {
      canBeSold,
      canBeSubscribed,
      price: {
        previousMinOfferPrice
      },
      productCode
    }
  } = (0, _internal.useProduct)();
  const {
    personalSubscriptionsEnabled
  } = (0, _internal.useSharedConfiguration)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const {
    isAnonymousUser
  } = (0, _auth.useToken)();
  const {
    isSubscriptionReplacement
  } = (0, _internal.useReplaceSubscriptionData)();
  const lowestPreviousPriceText = previousMinOfferPrice ? `${translations.lowestPrice} ${previousMinOfferPrice}` : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.BUTTONS),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PrimaryButton.PrimaryButton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_favoritesHeart.FavoritesHeartIconButton, {
          "aria-label": translations.favorites,
          code: productCode,
          "data-testid": getTestId(_constants.FAVORITES_HEART)
        })
      })]
    }), !isSubscriptionReplacement && canBeSold && canBeSubscribed && !isAnonymousUser && !personalSubscriptionsEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscribeButton.SubscribeButton, {
      isPrimary: false
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.InfoText, {
      text: lowestPreviousPriceText,
      testId: getTestId(_presentationComponents.LOWEST_PREVIOUS_PRICE)
    })]
  });
};
exports.Buttons = Buttons;
